module.exports = __webpack_public_path__ + "static/media/AG.4cca8671.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AG.svg
// module id = 186
// module chunks = 0